module.exports = __webpack_public_path__ + "static/media/explore-step3-img.7168042d.png";